module.exports = __webpack_public_path__ + "img/close-icon.695b826e.svg";